import React from 'react';
import '../Text/text.css'

const Text = ({ input, label, icon, unit, disabled, options, meta: { name, touched, error } }) => {

    return (
	
	<div className={['electroInput', (( error) ? 'error' : ''), ((input.value) ? 'touched' : '')].join(" ")} >
	    <div>
		
		<label htmlFor={input.name}>
		    {label}
		    
		    <span className="errorLabel"> - {error}</span>
		</label>
		
		<select {...input} id={input.name} disabled={disabled} autoComplete="off" placeholder={label}   >
		    {options ? options.map((o, index) => <option key={index} value={o.value}>{o.name}</option>) : null}
		</select>
	    </div>
	</div>
    )
}

export default Text



// WEBPACK FOOTER //
// ./src/components/Inputs/Select/Select.jsx